import React from 'react'

import { FooterBottom, FooterBottomProps } from './FooterBottom'
import { FooterInfoBar, FooterInfoBarProps } from './FooterInfoBar'
import { FooterMain, FooterMainProps } from './FooterMain'
import { FooterSubscribe, FooterSubscribeProps } from './FooterSubscribe'
import { FooterWrapper, FooterWrapperProps } from './FooterWrapper'

export type FooterProps =
  | ({
    wrapper: true;
    subscribe?: false;
    main?: false;
    infoBar?: false;
    bottom?: false;
  } & FooterWrapperProps)
  | ({
    wrapper?: false;
    subscribe: true;
    main?: false;
    infoBar?: false;
    bottom?: false;
  } & FooterSubscribeProps)
  | ({
    wrapper?: false;
    subscribe?: false;
    main: true;
    infoBar?: false;
    bottom?: false;
  } & FooterMainProps)
  | ({
    wrapper?: false;
    subscribe?: false;
    main?: false;
    infoBar: true;
    bottom?: false;
  } & FooterInfoBarProps)
  | ({
    wrapper?: false;
    subscribe?: false;
    main?: false;
    infoBar?: false;
    bottom: true;
  } & FooterBottomProps)


export const Footer: React.FC<FooterProps> = ({ wrapper, subscribe, main, infoBar, bottom, ...props }) => {
  if (bottom) {
    return (
      <FooterBottom {...props as FooterBottomProps} />
    )
  }

  if (infoBar) {
    return (
      <FooterInfoBar {...props as FooterInfoBarProps} />
    )
  }

  if (subscribe) {
    return (
      <FooterSubscribe {...props as FooterSubscribeProps} />
    )
  }

  if (main) {
    return (
      <FooterMain {...props as FooterMainProps} />
    )
  }

  return (
    <FooterWrapper {...props as FooterWrapperProps} />
  )
}
